import React, {ReactElement, ReactNode, useEffect, useRef, useState} from 'react';

import {InnerFilterValue, InnerSortingValue} from '../../../../types/grid2.0';

import {Filtration} from './Filtration';
import {Sorting} from './Sorting';
import {Root} from './styled';

interface Props {
    header: ReactNode;
    filterComponent?: ReactElement;
    filterValue?: InnerFilterValue;
    onFilterChange?: (value: InnerFilterValue) => void;
    onFilterReset?: () => void;
    sortingValue?: boolean;
    onSortingChange?: (value: InnerSortingValue) => void;
    hideHeader?: boolean;
    className?: string;
}

export const HeaderWrapper = ({
    header,
    filterComponent,
    filterValue,
    onFilterChange,
    onFilterReset,
    sortingValue,
    onSortingChange,
    hideHeader,
    className,
}: Props) => {
    const rootRef = useRef(null);
    const [, setState] = useState(0);

    // Force rerender to update ref
    useEffect(() => {
        setState(1);
    }, []);

    return (
        <Root className={className} ref={rootRef}>
            {!hideHeader && header}
            {onSortingChange && <Sorting value={sortingValue} onChange={onSortingChange} />}
            {filterComponent && onFilterChange && onFilterReset && (
                <Filtration
                    header={header}
                    component={filterComponent}
                    value={filterValue}
                    onChange={onFilterChange}
                    onReset={onFilterReset}
                    parentRef={rootRef.current ?? undefined}
                />
            )}
        </Root>
    );
};
